export default __webpack_public_path__ + "static/media/Fire_Water_Tanks.f7ad0298.jpg";